import {
  CHATBOT_INTERACT,
  CHATBOT_INTERACT_SUCCESS,
  CHATBOT_INTERACT_FAILURE,
  CHATBOT_VOICETOTEXT,
  CHATBOT_VOICETOTEXT_SUCCESS,
  CHATBOT_VOICETOTEXT_FAILURE,
} from "./actionType";

const initialState = {
  chatbotInteractData: [],
  chatbotInteractDataLoading: false,

  chatbotVoiceToTextData: [],
  chatbotVoiceToTextDataLoading: false,
};

export default function ChatCrmit(state = initialState, action) {
  switch (action.type) {
    case CHATBOT_INTERACT:
      return {
        ...state,
        chatbotInteractDataLoading: true,
      };
    case CHATBOT_INTERACT_SUCCESS:
      return {
        ...state,
        chatbotInteractData: action.payload,
        chatbotInteractDataLoading: false,
      };
    case CHATBOT_INTERACT_FAILURE:
      return {
        ...state,
        chatbotInteractData: action.payload,
        chatbotInteractDataLoading: false,
      };
    case CHATBOT_VOICETOTEXT:
      return {
        ...state,
        chatbotVoiceToTextDataLoading: true,
      };
    case CHATBOT_VOICETOTEXT_SUCCESS:
      return {
        ...state,
        chatbotVoiceToTextData: action.payload,
        chatbotVoiceToTextDataLoading: false,
      };
    case CHATBOT_VOICETOTEXT_FAILURE:
      return {
        ...state,
        chatbotVoiceToTextData: action.payload,
        chatbotVoiceToTextDataLoading: false,
      };
    default:
      return state;
  }
}
